import { Box, Container, Typography } from '@mui/material';
import { SectionLabel } from '../components/primitives';

/**
 * Stand-in for a module that has not been ported yet.
 *
 * Deliberately explicit rather than a blank page: during the phased cutover a
 * staff member who opens one of these needs to know the screen is coming, not
 * that something broke.
 */
export function Placeholder({ title, description }: { title: string; description: string }): React.JSX.Element {
    return (
        <Container maxWidth="xl" sx={{ pt: 3, pb: 4, px: { xs: 2, md: 3 } }}>
            <SectionLabel>{title}</SectionLabel>
            <Box sx={{ py: 6, textAlign: 'center' }}>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                    {title}
                </Typography>
                <Typography color="text.secondary" sx={{ mb: 2 }}>
                    {description}
                </Typography>
                <Typography sx={{ color: 'text.disabled', fontStyle: 'italic', fontSize: '0.85rem' }}>
                    Not yet migrated — still served by the existing system.
                </Typography>
            </Box>
        </Container>
    );
}
